import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { CallStatus } from '@ngrx-traits/signals';
import { ContentContainerComponent } from '@shared/preloader';
import { PreviewSelectionComponent } from '../helper/preview/preview.component';

@Component({
    selector: 'kt-formly-field-selection',
    templateUrl: './selection.component.html',
    styleUrl: './selection.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ContentContainerComponent,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatIconModule,
        PreviewSelectionComponent,
    ]
})
export class FormlyFieldSelectionComponent extends FieldType<FieldTypeConfig> {
  readonly callStatus = signal<CallStatus>('init');

  get visible() {
    return Array.isArray(this.field.formControl?.value) ?
      this.field.formControl.value?.filter(Boolean)?.length :
      this.field.formControl.value !== undefined && this.field.formControl.value !== null;
  }

  removeSelection(value: any): void {
    if (Array.isArray(this.formControl.value)) {
      this.formControl.setValue(this.formControl.value.filter((v: any) => v !== value));
    } else {
      this.formControl.setValue(undefined);
    }
  }
}
